import { DigitalPlatformSections1 } from '../components/DigitalPlatform1/constants';

export const isBY = window.location.hostname.endsWith('.by');
// для теста
// export const isBY = true;

export const CONTACTS = {
  ADRESS: isBY ? 'г. Минск, ул. Логойский тракт, д. 22А' : 'г. Москва, Можайское шоссе, д.29',
  MAIL: isBY ? 'main.office@innerica.by' : 'office@innerica.ru',
  PHONE: isBY ? '+375 (29) 970-76-06' : '+7 (985) 305-05-41',
  TELEGRAM_NICK: isBY ? 'Kred_XIX' : 'Innerica',
};
export const ID_SECTION = {
  MAIN: {
    // id: 1,
    to: 'main1',
    label: '',
  },
  PLATFORM: {
    id: 1,
    to: 'platform1',
    label: 'Платформа',
  },
  PRODUCT: {
    id: 1,
    to: 'product',
    label: 'Продукты',
  },
  COMPANY: {
    id: 3,
    to: 'company',
    label: 'О компании',
    isHidden: isBY && true,
  },
  CLIENTS: {
    id: 7,
    to: 'clients1',
    label: 'Клиенты',
  },
  REVIEW: {
    id: 9,
    to: 'review1',
    label: 'Отзывы',
    isHidden: isBY && true,
  },
  BLOG: {
    id: 10,
    to: 'blog1',
    label: 'Блог',
    isHidden: isBY && true,
  },
  WITSML: {
    id: 11,
    to: 'Witsml',
    label: 'Witsml',
  },
};
export type MenuItem = {
  id: number;
  to: string;
  label: string;
  isHidden?: boolean;
  dropdownItems?: MenuItem[];
};
// export const HEADER_MENU_ITEMS: MenuItem[] = [
// export const getHeaderMenuItems = (isOtherPage: boolean): MenuItem[] => {
export const getHeaderMenuItems = (): MenuItem[] => {
  const isProductPage = window.location.pathname.startsWith('/product/');
  return [
    ID_SECTION.PLATFORM,
    {
      id: 0,
      to: ID_SECTION.PRODUCT.to,
      label: ID_SECTION.PRODUCT.label,
      dropdownItems: DigitalPlatformSections1.map(section => ({
        label: section.Name,
        // to: isOtherPage ? `product/${section.EnName}`:`${section.EnName}`,
        to: isProductPage ? `${section.EnName}` : `product/${section.EnName}`,
        id: section.Id,
      })),
    },
    {
      ...ID_SECTION.COMPANY,
      // isHidden: isBY
    },
    ID_SECTION.CLIENTS,
    ID_SECTION.REVIEW,
    ID_SECTION.BLOG,
  ];
};

export const FOOTER_MENU_ITEMS: MenuItem[] = [
  ID_SECTION.PLATFORM,
  ...(!isBY ? [ID_SECTION.COMPANY] : []),
  ID_SECTION.CLIENTS,
  ...(!isBY ? [ID_SECTION.REVIEW] : []),
];
